"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberError = void 0;
exports.numberError = 'Valor deve ser númerico!';
var validateNumber = function (number) {
    var hasOnlyNumbers = /^\d+$/g.test(number);
    if (hasOnlyNumbers)
        return false;
    return exports.numberError;
};
exports.default = validateNumber;
//# sourceMappingURL=number.js.map